import * as React from "react";

import { CircularProgress, Button } from "@material-ui/core";
import { ButtonProps } from "@material-ui/core/Button";

interface IProps extends ButtonProps {
  disabled?: boolean;
  loading: boolean;
}

export default function ButtonSpinner(props: IProps) {
  const { loading, children, disabled, ...other } = props;

  return (
    <Button {...other} disabled={loading || disabled}>
      {!loading && props.children}
      {loading && (
        <CircularProgress size={20} color="primary" className="spinner" />
      )}
    </Button>
  );
}
